import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import { AddBPointsGamesResultLayer } from '../components/GamesPoints/AddBPointsGamesResultLayer'

export const AddBPointsGamesResultPage = () => {
  return (
    <MasterLayout>
        <AddBPointsGamesResultLayer />
    </MasterLayout>
  )
}
